import React, { useState } from "react";

import { Icon } from 'react-icons-kit';
import { check } from 'react-icons-kit/feather/check'

import styles from "../../../pages/DashBoard/ExternalDash/Issuer/ChangeRequest.module.css"
import TableStyles from "../../../pages/DashBoard/AllUsers.module.css"

export default function RequestedDocFields({ data, docfields, update, ischecked, checkField, getPdf, pdfLoading }) {

    const [loadShimmer, setLoadshimmer] = useState(0)


    if (loadShimmer == 3) {
        return (
            <section className={styles.searchBox}>
                <h2 className='topTitleBarText'>
                    <div className="shimmer" style={{ width: '5rem', height: '2rem' }} />
                </h2>
                <div className='shimmer' style={{ width: "100%", height: "5rem" }}>
                </div>
            </section>)
    }
    return (
        <table>
            <tbody>
                <tr className={TableStyles.chevronSortTableCell5}>
                    <th className={TableStyles.tablescell + " " + styles.th}>
                        Field Name
                    </th>
                    <th className={TableStyles.tablescell + " " + styles.th}>
                        Original Value
                    </th>
                    <th className={TableStyles.tablescell + " " + styles.th}>
                        Requested Value
                    </th>
                    <th></th>
                    <th className={TableStyles.tablescell + " " + styles.th}>
                        Supporting Document
                    </th>
                    <th className={TableStyles.tablescell + " " + styles.th}>
                        Enter Value
                    </th>
                </tr>
                {data?.discrepancy_log_data.details.map((i, index) => {
                    let checked = ischecked.includes(i.doc_field_id)
                    return (
                        <tr className={TableStyles.chevronSortTableCell} key={i.doc_field_id}>
                            <td className={styles.td + " " + TableStyles.tablescell}>
                                {i.doc_field_name.replace(/_/g," ")}
                            </td>
                            <td className={styles.td + " " + TableStyles.tablescell}>
                                {i.old_value}
                            </td>
                            <td className={styles.td + " " + TableStyles.tablescell}>
                                {i.estimated_correct_value}
                            </td>
                            <td>

                                
                                {/* <input type='checkbox' onChange={() => checkField(i.doc_field_id)}></input> */}
                            </td>
                            <td className={styles.td + " " + TableStyles.tablescell}>
                                <span className={i.supporting_document_name ? styles.Link : null} onClick={e => { pdfLoading == index ? null : getPdf(i, index) }}>
                                    {pdfLoading == index ? 'loading PDF..' : i.supporting_document_name || 'No document Added'}
                                </span>
                            </td>
                            <td className={styles.td + " " + TableStyles.tablescell}>
                                <input className={styles.input} type='text' value={docfields[index]?.estimated_correct_value} disabled={!checked} onChange={e => update(index, e.target.value)} />
                            </td>
                            <td className={styles.td + " " + TableStyles.tablescell}>
                            <div className={[styles.addMandatory, checked ? styles.added : styles.toadd].join(" ")} onClick={() => checkField(i.doc_field_id)}>
                                    <Icon icon={check} size={"0.6rem"} style={checked ? { color: "white" } : null} />
                            </div>
                            </td>
                        </tr>
                    )
                }
                )}
            </tbody>
        </table>
    )
}